import {
  COURSES_CART_ROUTE,
  COURSES_DETAIL_ROUTE,
  COURSES_OPTIONS_ROUTE,
  COURSES_STORE_ROUTE,
  HOME_ROUTE,
  MAIN_MENU_ROUTE,
  MY_COURSES_ROUTE,
  TIMETABLE_ROUTE,
  VIDEO_CARD_ROUTE,
  PAGE404_ROUTE,
  PAGE403_ROUTE,
  HOMEWORK_ROUTE,
  LESSON_ROUTE,
  COURSES_SUBJECT_COURSES,
  COURSES_THEMES,
  COURSES_THEMES_ID,
} from '../constants/constants';

import MainMenu from '../pages/MainMenu/MainMenu';
import Timetable from '../pages/Timetable/Timetable';
import VideoCard from '../pages/VideoCard/VideoCard';
import Home from '../pages/Home/Home';
import CourseAll from '../pages/CourseAll/CourseAll';
import CourseStoreDetail from '../pages/CourseStoreDetail/CourseStoreDetail';
import CourseStoreOptions from '../pages/CourseStoreOptions/CourseStoreOptions';
import CourseCart from '../pages/CourseCart/CourseCart';
import MyCourses from '../pages/MyCourses/MyCourses';
import Page403 from '../pages/ErrorPage/Page403';
import Page404 from '../pages/ErrorPage/Page404';
import Lesson from '../pages/Lesson/Lesson';
import Courses from '../pages/MyCourses/components/Courses/Courses';
import Paragraphs from '../pages/MyCourses/components/paragraphs/Paragraphs';
import Themes from '../pages/MyCourses/components/homework/Themes';

export const authRoutes = [
  {
    path: MAIN_MENU_ROUTE,
    Component: MainMenu,
  },
  // {
  //   path: TIMETABLE_ROUTE,
  //   Component: Timetable,
  // },
  {
    path: COURSES_STORE_ROUTE,
    Component: CourseAll,
  },
  {
    path: COURSES_DETAIL_ROUTE + '/:id',
    Component: CourseStoreDetail,
  },
  {
    path: COURSES_OPTIONS_ROUTE + '/:id',
    Component: CourseStoreOptions,
  },
  {
    path: COURSES_CART_ROUTE,
    Component: CourseCart,
  },
  {
    path: MY_COURSES_ROUTE,
    Component: MyCourses,
  },
  {
    path: VIDEO_CARD_ROUTE,
    Component: VideoCard,
  },
  {
    path: LESSON_ROUTE,
    Component: Lesson,
  },
  {
    path: COURSES_SUBJECT_COURSES,
    Component: Courses,
  },
  {
    path: COURSES_THEMES,
    Component: Paragraphs,
  },
  {
    path: COURSES_THEMES_ID,
    Component: Themes,
  },
];

export const publicRoutes = [
  {
    path: HOME_ROUTE,
    Component: Home,
  },
  {
    path: PAGE404_ROUTE,
    Component: Page404,
  },
  {
    path: PAGE403_ROUTE,
    Component: Page403,
  },
];


export const userHomePaths = {
  'student': MAIN_MENU_ROUTE,
  'admin': '/admin',
  'teacher': '/teachers-cabinet',
  'curator': '/curator',
  'anonymous': HOME_ROUTE
}